<template>
  <div class="ReportSearch">
      <div class="search-content clear">
          
            <div class="search-request clear" v-if="getCourseByKeyApi.key">
                <div class="float-left border">关键词：{{getCourseByKeyApi.key}} <i class="icon-del" @click="delkey"></i></div>
                <p class="float-left">共找到<span>{{rowCount}}</span>门<span>“{{getCourseByKeyApi.key}}”</span>相关报告</p>
            </div>
            <!-- 搜索结果 -->
            <!-- <div class="search-nav">
                <span>全部报告 </span> <template>> <span v-if="title">{{title}}</span><span v-if="getCourseByKeyApi.catecode !== ''">{{catename}}</span></template>
            </div> -->
            <!-- 搜索导航 -->

            <div class="search-class">
                <div class="big-class item">
                    <p class="name">行业大类：</p>
                    <div class="msg">
                        <span :class="{active: getCourseByKeyApi.catecode == ''}" @click="tabCatecode('')">全部</span>
                        <span v-for="(item,index) in reportType" :key="index" :class="{active: getCourseByKeyApi.catecode == item.code}" @click="tabCatecode(item.code)">{{item.name}}</span>
                    </div>
                </div>
                <div class="small-class item" v-if="getCourseByKeyApi.catecode !== ''">
                    <p class="name">行业小类：</p>
                    <div class="msg">
                        <div><span :class="{active: getCourseByKeyApi.catecode2 == ''}" @click="tabCatecode2('')">全部</span></div>
                        <div v-for="(item,index) in reportType" :key="index">
                            <template v-if="getCourseByKeyApi.catecode !== ''">
                                <template v-if="item.code == getCourseByKeyApi.catecode">
                                    <span v-for="(items,indexs) in item.content" :key="indexs" :class="{active: getCourseByKeyApi.catecode2 == items.code}" @click="tabCatecode2(items.code)">{{items.name}}</span>
                                </template>
                            </template>
                            <!-- <template v-else>
                                <span v-for="(items,indexs) in item.content" :key="indexs" :class="{active: getCourseByKeyApi.catecode2 == items.code}" @click="tabCatecode2(items.code)">{{items.name}}</span>
                            </template> -->
                        </div>
                    </div>
                </div>
                <div class="type item">
                    <p class="name">报告类型：</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in bgtype" :key="indexs" :class="{active: getCourseByKeyApi.feetype == items.code}" @click="tabFeetype(items.code)">{{items.name}}</span>
                    </div>
                </div>
                <div class="year item">
                    <p class="name">报告年份：</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in bgYear" :key="indexs" :class="{active: getCourseByKeyApi.reportyear == items.code}" @click="tabReportyear(items.code)">{{items.name}}</span>
                    </div>
                </div>
            </div>

            <!-- <div class="search-class" v-if="getCategoryByKeyData.grossclass > 0">
                <span key="0" :class="{'active': 0 === keyType}"  @click="tabkeyType(0, '')">
                    全部报告（{{getCategoryByKeyData.grossclass}}）</span>
                <span v-for="(item, index) in getCategoryByKeyData.datalist" :key="index + 1" @click="tabkeyType(index + 1, item.catecode), catename = item.catename" :class="{'active': index + 1 === keyType}">{{item.catename}}（{{item.classcount}}）</span>
            </div> -->
            <!-- 搜索类别 -->

            <div class="search-main">

                <div class="null" v-if="courselist.length === 0">
                    <img src="~common/images/search/search-null.png" alt="searchnull">
                    当前暂无报告
                </div>

                <div class="search-list clear" v-if="courselist.length > 0">
                    <!-- <StandardCourseCard></StandardCourseCard>
                    <StandardCourseCard></StandardCourseCard>
                    <StandardCourseCard></StandardCourseCard>
                    <StandardCourseCard></StandardCourseCard> -->
                    <StandardCourseCard v-for='(item, index) in courselist' :key='index' :data='item'></StandardCourseCard>
                </div>           
            </div>
            <!-- 搜索主体 -->

            <el-pagination background layout="prev, pager, next" :page-size="getCourseByKeyApi.pageSize" :current-page="getCourseByKeyApi.page" :total="rowCount" v-if="courselist.length > 0" @current-change="handleCurrentChange"></el-pagination>
            <!-- 分页 -->

            
      </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapActions, mapGetters} from 'vuex'
import types from './../reportindex/components/type.json' // 分类
import {getSearchResult} from 'api/reportApi'
// searchByKey, 
import StandardCourseCard from '../../pc/components/standardCourseCardTwo.vue'
export default {
    name: "ReportSearch",
      data() {
        return {
            reportType: [], // 报告分类
            bgtype: [{name:"全部", code: ""},{name:"免费", code: "1"},{name:"付费", code: "2"},{name:"会员", code: "3"}], // 报告类型
            bgYear: [{name:"全部", code: ""},{name:"2020", code: "2020"},{name:"2019", code: "2019"},{name:"2018", code: "2018"},{name:"2017", code: "2017"},{name:"2016", code: "2016"}], // 报告年份

            getCategoryByKeyData: {}, // 课程分类集合
            courselist: [], // 课程列表
            keyType: 0,    // 课程类别关键词选中下标
            getCourseByKeyApi: {
                key: this.$route.query.data ? decodeURI(this.$route.query.data) : '',   // 搜索关键词样式
                catecode: this.$route.query.catecode ? this.$route.query.catecode : '',   // 行业大类code
                catecode2: this.$route.query.typeData ? this.$route.query.typeData : '', // 行业小类code
                reportyear: this.$route.query.reportyear ? this.$route.query.reportyear : '', // 报告年份
                feetype: this.$route.query.feetype ? this.$route.query.feetype : '', // 资费类型 1免费 2收费
                hostid: this.$route.query.hostid ? this.$route.query.hostid : '', // 发布方ID
                kmctype: 2,  // 媒资类型 2报告 7课程 
                page: 1,   // 页码
                pageSize: 30,   // 每页记录数
            },
            catename: '',  // 分类名称
            rowCount: 0,
            title: this.$route.query.title,
        }
    },
    created() {
        if(this.domainInfo.isMobile){
            let routerQuery = {
                catecode: this.$route.query.catecode,
                feetype: this.$route.query.feetype,
                reportyear: this.$route.query.reportyear

            }
            if (this.$route.query.isMobile && this.$route.query.isMobile == 1) {
                routerQuery.key = this.$route.query.data ? this.$route.query.data: ''
            } else {
                routerQuery.key = this.$route.query.data ? encodeURI(this.$route.query.data): ''
            }
            
            this.$router.push({
                name: 'MReportSearch',
                query: routerQuery
            })
        }
    },
    mounted() {
        this.reportType = types

        // 回到定点
        this._clearScrollTop()
        // if (!this.$route.query.data) {
        //    this.key = ''
        // } 
        this.getSearchResult(1)

    },
    methods: {
        getSearchResult(page) { // 获取报告列表
            this._clearScrollTop()
            this.getCourseByKeyApi.page = page
            let params = JSON.parse(JSON.stringify(this.getCourseByKeyApi))
            if (params.feetype === '3') {
                params.feetype = ''
                params.zjmemtype = 1
            }
            this.setLoading(true)
            getSearchResult({
                data: params,
                success: data => {
                    this.setLoading(false)
                    this.courselist = data.data.reportlist
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        tabCatecode(code) {
            this.getCourseByKeyApi.catecode = code 
            this.getCourseByKeyApi.catecode2 = ''
            this.getSearchResult(1)
        },
        tabCatecode2(code) {
            this.getCourseByKeyApi.catecode2 = code 
            this.getSearchResult(1)
        },
        tabFeetype(code) {
            this.getCourseByKeyApi.feetype = code 
            this.getSearchResult(1)
        },
        tabReportyear(code) {
            this.getCourseByKeyApi.reportyear = code
            this.getSearchResult(1)
        },
        handleCurrentChange(val) { // 页数发生变化时触发

            // this.getCourseByKeyApi.page = val

            // 页数发生变化，取得列表
            this.getSearchResult(val)

        },
        delkey() { // 清空选中关键词
            this.$router.push({name: 'ReportSearch'})
        },
        tabkeyType(index, catecode) { // 切管关键词类别

            this.keyType = index
            this.getCourseByKeyApi.catecode = catecode

            // 切换分类的同时，页数初始化为1
            this.getCourseByKeyApi.page = 1


            // 通过课程分类取得课程列表
            this._JustTable()
        },  
        _JustTable() {  
            // 判断题库||课程切换
            // 判断搜索题库还是课程
            this.getCourseByKeyList()
        },
        _clearScrollTop() { // 初始化滚动条高度
            this.$nextTick(() => {
                $('html').scrollTop(0)
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        $route: {
            handler (val) { // val 更新的, oldVal 过去的
                // this.key = val.query.data
                // this.title = val.query.title

                // // 切换搜索关键词后，初始化Api
                // this.getCourseByKeyApi = {
                //     key: this.key,    // 搜索关键词
                //     catecode: '',   // 分类code
                //     page: 1,   // 页码
                //     pagesize: 30,   // 每页记录数
                // }
                // // 下标初始化
                // this.keyType = 0 

                this.getCourseByKeyApi.key = val.query.data
                if (this.$route.query.catecode) {
                    this.getCourseByKeyApi.catecode = this.$route.query.catecode
                }
                this.getSearchResult(1)

                // this.getCategoryByKeyList()

            },
            // 深度观察监听
            deep: true
        }
    },
    computed: {
        ...mapGetters(
            ['domainlist', 'domainInfo']
        )
    },
    components: {
        StandardCourseCard
    }
}
</script>

<style lang="scss" type="text/scss" >
.ReportSearch {
    .standardCourseCard .title {
        font-size: 14px;
    }
    // margin-top: 80px;
    .el-menu {
        margin-bottom: 31px;
        .el-menu-item {
            font-size: 18px;
        }
        .el-menu-item.is-active {
            color: #409EFF !important;
        }
    }

    .null {
        margin-top: 120px;
        margin-bottom: 180px;
        text-align: center;
        color: #CADAEE;
        font-size: 18px;

        img {
            margin: auto;
            margin-bottom: 26px;
            width: 234px;
            height: 121px;
        }
    }
    .icon-del {
        display: inline-block;
        width: 10px;
        height: 10px;
        cursor: pointer;
        background: url('../../../common/images/search/del.png');
        background-size: 10px;
    }
    .search-content {
        margin: auto;
        /*padding-top: 30px;*/
        width: 1180px;

        .search-request {
            margin-bottom: 20px;
            .border {
                padding: 0 8px;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                border: dashed  1px #409EFF;
            }
            p {
                margin-left: 30px;
                line-height: 28px;
                font-size: 14px;

                span {
                    display: inline-block;
                    padding:  0 5px;
                    color: #409EFF
                }
            }
        }

        .search-class {
            margin-top: 20px;
            padding: 0 20px;
            overflow: hidden;
            background:rgba(255,255,255,1);
            // box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);
            border: solid 1px #eee;

            .item {
                padding-top: 20px;
                overflow: hidden;
                
                &~.item {
                    border-top: solid 1px #eee;
                }
            }
            .name {
                float: left;
                display: block;
                width: 83px;
            }    
            .msg {
                float: left;
                width: calc(100% - 83px);
            }

            span {
                float: left;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                margin-bottom: 15px;
                font-size: 12px;
                margin-left: 30px;
                cursor: pointer;

                &.active {
                    font-size: 12px;
                    padding: 0 7px;
                    color: #fff;
                    background:#409EFF;
                    border-radius:10px;
                }
            }
        }
        
        .search-main {
            margin-top: 20px;
            .search-list {
                margin: 0 -20px 0 0;
            }
        }
        
        .el-pagination {
            margin-top: 20px;
            text-align: center
        }
    }
}
</style>